import { Component, ChangeDetectorRef, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatPaginator, MatSort } from '@angular/material';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { NgxCarousel } from 'ngx-carousel';
import { ReportsService } from '../reports/reports.service';
import { CompanyService } from '../company/company.service';
import { DatePipe } from '@angular/common';
import { SessionStorageService } from 'angular-web-storage';
import { VesselsService } from '../vessels/vessels.service';
import { AppCommonService } from 'src/app/app.common.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as _ from "lodash";
import { CookieService } from 'ngx-cookie-service';
import { Lightbox } from 'ngx-lightbox';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog'; // This should be the exact import
import { CommentDialogComponent } from '../comment-dialog/comment-dialog.component';
import { WeeklyworkreportService } from './weeklyworkreport.service';
import { NgZone } from '@angular/core';
import { ApiRootService } from '../apiroot.service';

@Component({
  selector: 'app-weeklyworkreport',
  templateUrl: './weeklyworkreport.component.html',
  styleUrls: ['./weeklyworkreport.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class WeeklyworkreportComponent implements OnInit {
  selectedImage: string | null = null;
  myForm: FormGroup;
  loading: boolean;
  showReports: boolean;
  userVesselData: any = [];
  companyList: any = [];
  currentVessel;
  formData: any;
  newCompanyId: number;
  newVesselId: number;
  userId: number;
  weeklyformlist: boolean;
  reportList: any[] = [];
  reportData: any;
  manualAPI: any = [];
  manualMRAPI: any = [];
  commentHolder: any
  gdReportData: any;
  reportVessel: any;
  logoBase64: string = 'data:image/png;base64,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';
  reportFromDateFormat;
  reportToDateFormat;
  updatedAtDate: string;
  currentCommentId: string;
  serverErrMsg: string = "The request took too long to respond. Please try again.";
  deviceErrMsg: string = "No internet connection detected. Please check your network.";
  selectedStatus: Number = 5;
  fromDate: string = '';
  toDate: string = '';
  filteredFormRecordsList: any[] = [];

  public Config: NgxCarousel = {
    grid: { xs: 2, sm: 3, md: 3, lg: 5, all: 0 },
    slide: 1,
    speed: 5,
    interval: 10000,
    point: {
      visible: true
    },
    touch: true,
    loop: false,
    custom: 'banner'
  };

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('successbox', { static: true }) successbox: SwalComponent;
  @ViewChild('errorbox', { static: true }) errorbox: SwalComponent;
  @ViewChild('closebox', { static: true }) closebox: SwalComponent;
  @ViewChild('deletebox', { static: true }) deletebox: SwalComponent;

  constructor(private cookieService: CookieService, private _lightbox: Lightbox, private domSanitizer: DomSanitizer, public cmps: CompanyService, public rs: ReportsService, public vs: VesselsService, public session: SessionStorageService, public fb: FormBuilder,
    public http: HttpClient,
    public commonService: AppCommonService,
    private router: Router,
    private dialog: MatDialog,
    public datePipe: DatePipe,
    public wwds: WeeklyworkreportService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    public service: ApiRootService
  ) { }

  ngOnInit() {
    var companyid = this.session.get('companyId');
    console.log("===companyId===", companyid)
    if (companyid) {
      this.getVesselList(companyid);
    } else {
      this.getCompanyList();
    }

    this.myForm = this.fb.group({
      'bookTypeId': new FormControl(null, [Validators.required])
    })

    this.userId = this.session.get('userid')
  }

  getCompanyList() {
    // console.log("Fetching company list...");
    this.cmps.getData((response) => {
      // console.log("Company list API response received:", response);
      if (response && response.data) {
        this.companyList = response.data;
        // console.log("Company list updated:", this.companyList);
      } else {
        // console.warn("Company list response is empty or invalid:", response);
      }
      this.cdr.markForCheck();
      // console.log("Change detection triggered for company list.");
    });
  }

  private setLoadingState(state: boolean): void {
    // console.log("Setting loading state to:", state);
    this.loading = state;
    // console.log("Loading state updated successfully.");
  }

  closeForm() {
    // console.log("Closing form...");
    this.formData = null;
    // console.log("Form data cleared.");
    // console.log("Removing query parameters...");
    this.router.navigate([], {
      queryParams: {
        'yourParamName': null,
        'youCanRemoveMultiple': null,
      },
      queryParamsHandling: 'merge'
    });
    // console.log("Query parameters removed successfully.");
  }

  selectCompany(id: number) {
    this.weeklyformlist = false;
    // console.log("Selecting company with ID:", id);
    this.userVesselData = [];
    this.newCompanyId = null;
    this.currentVessel = null;
    this.newVesselId = null;
    console.log('==currentVessel==', this.currentVessel)
    // console.log("Before reset -> userVesselData:", this.userVesselData);
    this.setLoadingState(true);
    // console.log("Loading state set to true.");
    this.newCompanyId = id;
    // console.log("New company ID updated:", this.newCompanyId);
    // console.log("Vessel ID reset to null.");
    this.getVesselList(id);
    // console.log("Fetching vessel list for company ID:", id);
    this.cdr.detectChanges()
  }

  getVesselList(id: number) {
    // console.log("Fetching vessel list for company ID:", id);
    this.userVesselData = [];
    this.vs.getDataByCompanyId(id, (response) => {
      // console.log("Vessel list API response received:", response);
      if (response && response.data) {
        this.userVesselData = response.data;
        this.currentVessel = null;
        // console.log("Vessel list updated:", this.userVesselData);
      } else {
        // console.warn("Vessel list response is empty or invalid:", response);
      }
      this.setLoadingState(false);
      // console.log("Loading state set to false after API response.");
      this.cdr.markForCheck();
      // console.log("Change detection triggered for vessel list update.");
    });
    this.setLoadingState(false);
    // console.log("Loading state set to false (outside API callback).");
  }

  getVesselData(event: number) {
    this.weeklyformlist = false;
    this.currentVessel = event;
    // console.log("Fetching vessel data for vessel ID:", event);
    this.newVesselId = event;
    // console.log("New vessel ID updated:", this.newVesselId);

    for (let key in this.userVesselData) {
      if (this.userVesselData[key].id == event) {
        this.showReports = false;
        // console.log("Reports visibility set to false for vessel ID:", event);
      }
    }

    this.vs.getDataById(event, (res) => {
      // console.log("Vessel data API response received:", res);
      if (res && res.data) {
        this.reportVessel = res.data.vesselName;
        // console.log("Report vessel name updated:", this.reportVessel);
      } else {
        // console.warn("Vessel data response is empty or invalid:", res);
      }
      this.cdr.markForCheck();
      // console.log("Change detection triggered for vessel data update.");
    });
  }

  in_array(array, id) {
    return array.some(function (o) { return o["section"] === id; })
  }

  getWeeklyReportList() {
    // console.log("Fetching weekly report list...");
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    console.log('New Company Id getweeklyworkReportList', this.newCompanyId)
    console.log('New Vessel Id getweeklyworkReportList', this.newVesselId)

    if (this.companyList.length === 0 && !this.newVesselId) {
      // console.warn("No vessel selected. Prompting user.");
      this.showError("Wait", "Please select a vessel before proceeding.");
      return;
    }
    if (this.companyList.length > 0 && (!this.newCompanyId || !this.newVesselId)) {
      // console.warn("Company or vessel not selected. Prompting user.");
      this.showError("Wait", "Please select a company and a vessel before proceeding.");
      return;
    }
    this.getWeeklyWorkReportList();
    // console.log("getWeeklyWorkReportList() executed.");
    this.updateFormStates();
    // console.log("updateFormStates() executed.");
  }

  updateFormStates() {
    // console.log("Updating form states...");
    this.weeklyformlist = true;
    // console.log("weeklyformlist set to true.");
    this.showReports = false;
    // console.log("showReports set to false.");
    this.formData = false; 8
    // console.log("formData set to false.");
  }

  showError(title: string, text: string) {
    // console.log("Displaying error message:", title, text);
    this.errorbox.title = title;
    // console.log("Error title set to:", title);
    this.errorbox.text = text;
    // console.log("Error text set to:", text);
    this.errorbox.show();
    // console.log("Error box shown.");
  }

  showSuccess(title: string, text: string) {
    // console.log("Displaying success message:", title, text);
    this.successbox.title = title;
    this.successbox.text = text;
    this.successbox.show();
    // console.log("Success message displayed with title:", this.successbox.title, "and text:", this.successbox.text);
  }

  getWeeklyWorkReportList() {
    // console.log("Fetching weekly work report list...");
    this.setLoadingState(true);
    // console.log("Loading state set to true.");
    this.rs.getWeeklyFormDataByVesselIdAndFormId(80, this.newVesselId, (response) => {
      this.setLoadingState(false);
      // console.log("Change detection triggered.");
      this.cdr.markForCheck();
      // console.log("Loading state set to false.");
      if (response && (Number(response.responsecode) == 200)) {
        this.reportList = response.data || [];
        this.filteredFormRecordsList = this.reportList;
        // console.log("Weekly work report data updated:", this.reportList);
      } else {
        this.reportList = [];
        // console.warn("Invalid response or empty data received.");
      }
    }, (error) => {
      // console.log('[API [Timeout]/Error]', error);
      this.showError("Connection Issue", this.serverErrMsg)
      this.setLoadingState(false);
      this, this.cdr.markForCheck();
    });
  }

  downloadPDF(pdfTitle: any) {
    // console.log("Starting PDF download...");
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }
    var node = document.getElementById('print-section');
    // console.log("print-section element found:", node);
    var newPdfTitle = pdfTitle ? pdfTitle : 'Title';
    // console.log("PDF title set to:", newPdfTitle);
    const clonedNode = node.cloneNode(true) as HTMLElement;
    // console.log("Cloned node created.");
    const addCommentButtons = clonedNode.querySelectorAll('.commentbuttonaTarget');
    // console.log("Comment buttons to be removed:", addCommentButtons.length);
    addCommentButtons.forEach(button => button.remove());
    // console.log("Removed all comment buttons from the cloned node.");
    const htmlContent = clonedNode.innerHTML;
    // console.log("Cloned HTML content prepared for PDF:", htmlContent);
    this.commonService.openDialog(htmlContent, newPdfTitle, '');
    // console.log("PDF dialog opened with title:", newPdfTitle);
  }

  showReportDetails(actionDate: any) {
    this.showReports = true;
  }

  viewWeeklyWorkReport(reportInfo) {
    // console.log("Starting to view weekly work report...");
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }
    this.manualAPI = [];
    this.manualMRAPI = [];
    this.setLoadingState(true);
    // console.log("Loading state set to true.");
    this.gdReportData = reportInfo;
    // console.log("Report info set:", reportInfo);
    this.updatedAtDate = this.formatUpdatedAtDate(this.gdReportData.updated_at);
    // console.log("Updated date formatted:", this.updatedAtDate);
    this.reportFromDateFormat = this.gdReportData.formDate;
    // console.log("Report from date:", this.reportFromDateFormat);
    this.reportToDateFormat = this.gdReportData.toDate;
    // console.log("Report to date:", this.reportToDateFormat);

    const formIds = "81,82,83";
    // console.log("Form IDs:", formIds);

    this.rs.getWeeklyIndiviualData(formIds, reportInfo.vesselId, reportInfo.id, (response) => {
      if (Number(response.responsecode) == 200) {
        this.reportData = response.data;
        console.log("Weekly report data received:", this.reportData);
        this.weeklyformlist = false;
        this.formData = false;
        this.showReports = true;
        this.setLoadingState(false);
        this.cdr.markForCheck();
        this.getManualRespone();
        this.getCommentsForAllQuestions();
        // console.log("Data processing completed.");
      } else {
        // console.log("Your weekly work individual data is not 200. Please check it.");
        this.setLoadingState(false);
        this.showError("Error", response.message);
        this.cdr.markForCheck();
      }
    }, (error) => {
      console.log('===error===', error);
      this.setLoadingState(false);
      this.showError("Connection Issue", this.serverErrMsg);
      this.cdr.markForCheck();
    });
  }

  formatUpdatedAtDate(dateString: string): string {
    // console.log("Received date string:", dateString);
    const dateObj = new Date(dateString);
    // console.log("Converted date object:", dateObj);
    if (isNaN(dateObj.getTime())) {
      // console.error("Invalid date string:", dateString);
      throw new Error("invalid date String");
    }
    const pad = (num: number) => String(num).padStart(2, '0');
    const day = pad(dateObj.getDate());
    // console.log("Formatted day:", day);
    const month = pad(dateObj.getMonth() + 1);
    // console.log("Formatted month:", month);
    const year = dateObj.getFullYear();
    // console.log("Formatted year:", year);
    const hour$ = dateObj.getHours();
    // console.log("Hour:", hour$);
    const minutes = pad(dateObj.getMinutes());
    // console.log("Formatted minutes:", minutes);
    const ampm = hour$ >= 12 ? 'PM' : 'AM';
    // console.log("AM/PM:", ampm);
    const formattedTime = `${hour$ % 12 || 12}:${minutes} ${ampm}`;
    // console.log("Formatted time:", formattedTime);
    const formattedDate = `${day}/${month}/${year} ${formattedTime}`;
    // console.log("Final formatted date:", formattedDate);
    return formattedDate;
  }

  openCommentDialog(fieldName: string, formId: number, rowId: number): void {
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    console.log("Opening comment dialog with:", { fieldName, formId, rowId, userId: this.userId, vesselId: this.newVesselId, objectId: this.gdReportData.id });
    const dialogRef = this.dialog.open(CommentDialogComponent, {
      width: '400px',
      data: {
        fieldName,
        formId,
        rowId,
        userId: this.userId,
        vesselId: this.newVesselId,
        objectId: this.gdReportData.id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // console.log("Dialog closed, result:", result);
        this.addNewComment(result.data.rowId, result.data.formId, result.data.fieldName);
        // console.log("New comment added for rowId:", result.data.rowId);
        setTimeout(() => {
          // console.log("Triggering change detection after comment addition");
          this.cdr.detectChanges();
        }, 500);
      } else {
        // console.log("Dialog closed with no result");
      }
    });
  }

  editCommentDialog(comment) {
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    // console.log("Opening edit comment dialog with comment data:", comment);
    const dialogRef = this.dialog.open(CommentDialogComponent, {
      width: '400px',
      data: {
        ...comment,
        userId: this.userId,
        vesselId: this.newVesselId,
        objectId: this.gdReportData.id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data) {
        // console.log("Dialog closed with result:", result);
        const updatedComment = {
          id: result.data.id,
          userName: result.data.commentBy || "Unknown",
          comment: result.data.comment,
          actionDateTime: result.data.actionDateTime,
          colour: result.data.colour,
          rowId: result.data.rowId,
          formId: result.data.formId,
          actionDateTimeFixedFormat: this.changeDateFormat(result.data.actionDateTime), // Custom formatting function
          fieldName: result.data.fieldName,
          status: result.data.status,
          userId: result.data.userId,
          commentSync: result.data.iSync || false
        };
        // console.log("Updated comment object:", updatedComment);
        const existingCommentIndex = this.commentHolder.findIndex(c => c.id === updatedComment.id);
        // console.log("Existing comment index in holder:", existingCommentIndex);
        if (existingCommentIndex !== -1) {
          // console.log("Updating existing comment in commentHolder at index:", existingCommentIndex);
          this.commentHolder[existingCommentIndex] = updatedComment;
        } else {
          // console.log("Adding new comment to commentHolder");
          this.commentHolder = [...this.commentHolder, updatedComment];
        }
        // console.log("Updated comment holder:", this.commentHolder);
        this.cdr.detectChanges();
      } else {
        // console.log("Dialog closed with no result or no data");
      }
    });
  }

  private changeDateFormat(timestamp: number): string {
    // console.log("Received timestamp:", timestamp);
    const date = new Date(timestamp);
    // console.log("Converted date object:", date);
    const formattedDate = `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    // console.log("Formatted date:", formattedDate);
    return formattedDate;
  }


  confirmationDelete(comment) {
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    this.currentCommentId = comment.id;
    // console.log("Current Comment ID:", this.currentCommentId);
    this.deletebox.show();
  }

  deleteComment() {
    // console.log("Deleting comment with ID:", this.currentCommentId);
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    this.wwds.deleteCommentByCommentId(this.currentCommentId, (response) => {
      // console.log("Response from delete operation:", res);
      if (Number(response.responsecode) == 200) {
        this.showSuccess("Deleted Successfully", "Your comment has been successfully deleted.")
        this.commentHolder = this.commentHolder.filter(comment => comment.id !== this.currentCommentId);
        // console.log("Updated comment holder:", this.commentHolder);
        this.cdr.detectChanges();
      } else {
        this.showError("Error", "Unable to Delete");
      }
    });
  }

  getAnswer(fieldPath: string): string {
    // console.log("Field Path:", fieldPath);
    const result = fieldPath.split('.').reduce((acc, curr) => {
      // console.log("Accumulator:", acc, "Current Key:", curr);
      return acc && acc[curr] ? acc[curr] : '';
    }, this.reportData[0]);
    // console.log("Final Result:", result);
    return result;
  }

  getImages(imageFieldPath: string): string[] {
    // console.log("Image Field Path:", imageFieldPath);
    const images = imageFieldPath.split('.').reduce((acc, curr) => {
      // console.log("Accumulator:", acc, "Current Key:", curr);
      return acc && acc[curr] ? acc[curr] : null;
    }, this.reportData[0]);
    // console.log("Images Found:", images);
    return images ? images.map(image => image.base64) : [];
  }



  getManualRespone() {

    var wwd_hseq = (this.reportData && this.reportData[0] && this.reportData[0].wwd_hseq && this.reportData[0].wwd_hseq[0])
      ? this.reportData[0].wwd_hseq[0] : '';

    var wwd_technical = (this.reportData && this.reportData[1] && this.reportData[1].wwd_technical && this.reportData[1].wwd_technical[0])
      ? this.reportData[1].wwd_technical[0] : ''

    var wwd_mlc = (this.reportData && this.reportData[2] && this.reportData[2].wwd_mlc && this.reportData[2].wwd_mlc[0])
      ? this.reportData[2].wwd_mlc[0] : ''
    var isImageUrlHseq =  (wwd_hseq && wwd_hseq.isImageUrl)? wwd_hseq.isImageUrl:false;
    var isImageUrlTechnical =  (wwd_technical && wwd_technical.isImageUrl)? wwd_technical.isImageUrl:false;
    var isImageUrlMlc =  (wwd_mlc && wwd_mlc.isImageUrl)? wwd_mlc.isImageUrl:false;
    var imgBaseUrl=this.service.getBaseUrl() + '/downloadWwdImageFile/';

    // console.log("===wwd_mlc.images.mlc_Sanitary_Laundry_Facilities_Image===",wwd_mlc.images.mlc_Sanitary_Laundry_Facilities_Image);

    this.manualAPI = [
      {
        "dropdownName": "Deck",
        "rowId": (wwd_hseq && wwd_hseq.rowId) ? wwd_hseq.rowId : '',
        "formId": (wwd_hseq && wwd_hseq.formId) ? wwd_hseq.formId : '',
        'is_sync': (wwd_hseq && wwd_hseq.is_sync) ? wwd_hseq.is_sync : '',
        "questions": [
          {
            "question": "Monday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.deck_Monday) ? wwd_hseq.deck_Monday : '',
              "fieldName": "deck_Monday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.deck_Monday_Image)
                ? wwd_hseq.images.deck_Monday_Image.map(image => ({

                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "deck_Monday_Image",
              "comments": []
            }
          },
          {
            "question": "Tuesday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.deck_Tuesday) ? wwd_hseq.deck_Tuesday : '',
              "fieldName": "deck_Tuesday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.deck_Tuesday_Image)
                ? wwd_hseq.images.deck_Tuesday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "deck_Tuesday_Image",
              "comments": []
            }
          },
          {
            "question": "Wednesday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.deck_Wednesday) ? wwd_hseq.deck_Wednesday : '',
              "fieldName": "deck_Wednesday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.deck_Wednesday_Image)
                ? wwd_hseq.images.deck_Wednesday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "deck_Wednesday_Image",
              "comments": []
            }
          },
          {
            "question": "Thursday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.deck_Thursday) ? wwd_hseq.deck_Thursday : '',
              "fieldName": "deck_Thursday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.deck_Thursday_Image)
                ? wwd_hseq.images.deck_Thursday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "deck_Thursday_Image",
              "comments": []
            }
          },
          {
            "question": "Friday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.deck_Friday) ? wwd_hseq.deck_Friday : '',
              "fieldName": "deck_Friday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.deck_Friday_Image)
                ? wwd_hseq.images.deck_Friday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "deck_Friday_Image",
              "comments": []
            }
          },
          {
            "question": "Saturday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.deck_Saturday) ? wwd_hseq.deck_Saturday : '',
              "fieldName": "deck_Saturday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.deck_Saturday_Image)
                ? wwd_hseq.images.deck_Saturday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "deck_Saturday_Image",
              "comments": []
            }
          },
          {
            "question": "Sunday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.deck_Sunday) ? wwd_hseq.deck_Sunday : '',
              "fieldName": "deck_Sunday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.deck_Sunday_Image)
                ? wwd_hseq.images.deck_Sunday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "deck_Sunday_Image",
              "comments": []
            }
          }
        ]
      },

      // LSA FFA
      {
        "dropdownName": "LSA FFA",
        "rowId": (wwd_hseq && wwd_hseq.rowId) ? wwd_hseq.rowId : '',
        "formId": (wwd_hseq && wwd_hseq.formId) ? wwd_hseq.formId : '',
        'is_sync': (wwd_hseq && wwd_hseq.is_sync) ? wwd_hseq.is_sync : '',
        "questions": [
          {
            "question": "Monday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.lsa_Ffa_Monday) ? wwd_hseq.lsa_Ffa_Monday : '',
              "fieldName": "lsa_Ffa_Monday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.lsa_ffa_Monday_Image)
                ? wwd_hseq.images.lsa_ffa_Monday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "lsa_ffa_Monday_Image",
              "comments": []
            }
          },
          {
            "question": "Tuesday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.lsa_Ffa_Tuesday) ? wwd_hseq.lsa_Ffa_Tuesday : '',
              "fieldName": "lsa_Ffa_Tuesday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.lsa_Ffa_Tuesday_Image)
                ? wwd_hseq.images.lsa_Ffa_Tuesday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "lsa_Ffa_Tuesday_Image",
              "comments": []
            }
          },
          {
            "question": "Wednesday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.lsa_Ffa_Wednesday) ? wwd_hseq.lsa_Ffa_Wednesday : '',
              "fieldName": "lsa_Ffa_Wednesday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.lsa_Ffa_Wednesday_Image)
                ? wwd_hseq.images.lsa_Ffa_Wednesday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "lsa_Ffa_Wednesday_Image",
              "comments": []
            }
          },
          {
            "question": "Thursday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.lsa_Ffa_Thursday) ? wwd_hseq.lsa_Ffa_Thursday : '',
              "fieldName": "lsa_Ffa_Thursday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.lsa_Ffa_Thursday_Image)
                ? wwd_hseq.images.lsa_Ffa_Thursday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "lsa_Ffa_Thursday_Image",
              "comments": []
            }
          },
          {
            "question": "Friday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.lsa_Ffa_Friday) ? wwd_hseq.lsa_Ffa_Friday : '',
              "fieldName": "lsa_Ffa_Friday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.lsa_Ffa_Friday_Image)
                ? wwd_hseq.images.lsa_Ffa_Friday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "lsa_Ffa_Friday_Image",
              "comments": []
            }
          },
          {
            "question": "Saturday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.lsa_Ffa_Saturday) ? wwd_hseq.lsa_Ffa_Saturday : '',
              "fieldName": "lsa_Ffa_Saturday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.lsa_Ffa_Saturday_Image)
                ? wwd_hseq.images.lsa_Ffa_Saturday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "lsa_Ffa_Saturday_Image",
              "comments": []
            }
          },
          {
            "question": "Sunday",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.lsa_Ffa_Sunday) ? wwd_hseq.lsa_Ffa_Sunday : '',
              "fieldName": "lsa_Ffa_Sunday",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.lsa_Ffa_Sunday_Image)
                ? wwd_hseq.images.lsa_Ffa_Sunday_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "lsa_Ffa_Sunday_Image",
              "comments": []
            }
          }
        ]
      },

      // Certification
      {
        "dropdownName": "Certifications",
        "rowId": (wwd_hseq && wwd_hseq.rowId) ? wwd_hseq.rowId : '',
        "formId": (wwd_hseq && wwd_hseq.formId) ? wwd_hseq.formId : '',
        'is_sync': (wwd_hseq && wwd_hseq.is_sync) ? wwd_hseq.is_sync : '',
        "questions": [
          {
            "question": "Certifications due in next 3 months",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.cert_Due_3M) ? wwd_hseq.cert_Due_3M : '',
              "fieldName": "cert_Due_3M",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.cert_Due_3M_Image)
                ? wwd_hseq.images.cert_Due_3M_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "cert_Due_3M_Image",
              "comments": []
            }
          },
          {
            "question": "Condition of Class due in next 3 months",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.cert_class_Cond_Due_3M) ? wwd_hseq.cert_class_Cond_Due_3M : '',
              "fieldName": "cert_class_Cond_Due_3M",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.cert_class_Cond_Due_3M_Image)
                ? wwd_hseq.images.cert_class_Cond_Due_3M_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "cert_Due_3M_Image",
              "comments": []
            }
          },
          {
            "question": "Annual Surveys/Flag State Inspections due in next 3 months",
            "answer": {
              "text": (wwd_hseq && wwd_hseq.cert_survey_Flag_Due_3M) ? wwd_hseq.cert_survey_Flag_Due_3M : '',
              "fieldName": "cert_survey_Flag_Due_3M",
              "comments": []
            },
            "images": {
              "list": (wwd_hseq && wwd_hseq.images && wwd_hseq.images.cert_survey_Flag_Due_3M_Image)
                ? wwd_hseq.images.cert_survey_Flag_Due_3M_Image.map(image => ({
                    src: isImageUrlHseq ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "cert_Due_3M_Image",
              "comments": []
            }
          }
        ]
      },

      // Engine + Electrical
      {
        "dropdownName": "Engine + Electrical",
        "rowId": (wwd_technical && wwd_technical.rowId) ? wwd_technical.rowId : '',
        "formId": (wwd_technical && wwd_technical.formId) ? wwd_technical.formId : '',
        'is_sync': (wwd_technical && wwd_technical.is_sync) ? wwd_technical.is_sync : '',
        "questions": [
          {
            "question": "Monday",
            "answer": {
              "text": (wwd_technical && wwd_technical.engine_Electrical_Monday) ? wwd_technical.engine_Electrical_Monday : '',
              "fieldName": "engine_Electrical_Monday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.engine_Electrical_Monday_Image)
                ? wwd_technical.images.engine_Electrical_Monday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "engine_Electrical_Monday_Image",
              "comments": []
            }
          },
          {
            "question": "Tuesday",
            "answer": {
              "text": (wwd_technical && wwd_technical.engine_Electrical_Tuesday) ? wwd_technical.engine_Electrical_Tuesday : '',
              "fieldName": "engine_Electrical_Tuesday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.engine_Electrical_Tuesday_Image)
                ? wwd_technical.images.engine_Electrical_Tuesday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "engine_Electrical_Tuesday_Image",
              "comments": []
            }
          },
          {
            "question": "Wednesday",
            "answer": {
              "text": (wwd_technical && wwd_technical.engine_Electrical_Wednesday) ? wwd_technical.engine_Electrical_Wednesday : '',
              "fieldName": "engine_Electrical_Wednesday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.engine_Electrical_Wednesday_Image)
                ? wwd_technical.images.engine_Electrical_Wednesday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "engine_Electrical_Wednesday_Image",
              "comments": []
            }
          },
          {
            "question": "Thursday",
            "answer": {
              "text": (wwd_technical && wwd_technical.engine_Electrical_Thursday) ? wwd_technical.engine_Electrical_Thursday : '',
              "fieldName": "engine_Electrical_Thursday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.engine_Electrical_Thursday_Image)
                ? wwd_technical.images.engine_Electrical_Thursday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "engine_Electrical_Thursday_Image",
              "comments": []
            }
          },
          {
            "question": "Friday",
            "answer": {
              "text": (wwd_technical && wwd_technical.engine_Electrical_Friday) ? wwd_technical.engine_Electrical_Friday : '',
              "fieldName": "engine_Electrical_Friday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.engine_Electrical_Friday_Image)
                ? wwd_technical.images.engine_Electrical_Friday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "engine_Electrical_Friday_Image",
              "comments": []
            }
          },
          {
            "question": "Saturday",
            "answer": {
              "text": (wwd_technical && wwd_technical.engine_Electrical_Saturday) ? wwd_technical.engine_Electrical_Saturday : '',
              "fieldName": "engine_Electrical_Saturday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.engine_Electrical_Saturday_Image)
                ? wwd_technical.images.engine_Electrical_Saturday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "engine_Electrical_Saturday_Image",
              "comments": []
            }
          },
          {
            "question": "Sunday",
            "answer": {
              "text": (wwd_technical && wwd_technical.engine_Electrical_Sunday) ? wwd_technical.engine_Electrical_Sunday : '',
              "fieldName": "engine_Electrical_Sunday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.engine_Electrical_Sunday_Image)
                ? wwd_technical.images.engine_Electrical_Sunday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "engine_Electrical_Sunday_Image",
              "comments": []
            }
          }
        ]
      },

      // Riding Squad Deck + Engine
      {
        "dropdownName": "Riding Squad Deck + Engine",
        "rowId": (wwd_technical && wwd_technical.rowId) ? wwd_technical.rowId : '',
        "formId": (wwd_technical && wwd_technical.formId) ? wwd_technical.formId : '',
        'is_sync': (wwd_technical && wwd_technical.is_sync) ? wwd_technical.is_sync : '',
        "questions": [
          {
            "question": "Monday",
            "answer": {
              "text": (wwd_technical && wwd_technical.rsd_Engine_Monday) ? wwd_technical.rsd_Engine_Monday : '',
              "fieldName": "rsd_Engine_Monday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.rsd_Engine_Monday_Image)
                ? wwd_technical.images.rsd_Engine_Monday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "rsd_Engine_Monday_Image",
              "comments": []
            }
          },
          {
            "question": "Tuesday",
            "answer": {
              "text": (wwd_technical && wwd_technical.rsd_Engine_Tuesday) ? wwd_technical.rsd_Engine_Tuesday : '',
              "fieldName": "rsd_Engine_Tuesday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.rsd_Engine_Tuesday_Image)
                ? wwd_technical.images.rsd_Engine_Tuesday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "rsd_Engine_Tuesday_Image",
              "comments": []
            }
          },
          {
            "question": "Wednesday",
            "answer": {
              "text": (wwd_technical && wwd_technical.rsd_Engine_Wednesday) ? wwd_technical.rsd_Engine_Wednesday : '',
              "fieldName": "rsd_Engine_Wednesday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.rsd_Engine_Wednesday_Image)
                ? wwd_technical.images.rsd_Engine_Wednesday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "rsd_Engine_Wednesday_Image",
              "comments": []
            }
          },
          {
            "question": "Thursday",
            "answer": {
              "text": (wwd_technical && wwd_technical.rsd_Engine_Thursday) ? wwd_technical.rsd_Engine_Thursday : '',
              "fieldName": "rsd_Engine_Thursday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.rsd_Engine_Thursday_Image)
                ? wwd_technical.images.rsd_Engine_Thursday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "rsd_Engine_Thursday_Image",
              "comments": []
            }
          },
          {
            "question": "Friday",
            "answer": {
              "text": (wwd_technical && wwd_technical.rsd_Engine_Friday) ? wwd_technical.rsd_Engine_Friday : '',
              "fieldName": "rsd_Engine_Friday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.rsd_Engine_Friday_Image)
                ? wwd_technical.images.rsd_Engine_Friday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "rsd_Engine_Friday_Image",
              "comments": []
            }
          },
          {
            "question": "Saturday",
            "answer": {
              "text": (wwd_technical && wwd_technical.rsd_Engine_Saturday) ? wwd_technical.rsd_Engine_Saturday : '',
              "fieldName": "rsd_Engine_Saturday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.rsd_Engine_Saturday_Image)
                ? wwd_technical.images.rsd_Engine_Saturday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "rsd_Engine_Saturday_Image",
              "comments": []
            }
          },
          {
            "question": "Sunday",
            "answer": {
              "text": (wwd_technical && wwd_technical.rsd_Engine_Sunday) ? wwd_technical.rsd_Engine_Sunday : '',
              "fieldName": "rsd_Engine_Sunday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.rsd_Engine_Sunday_Image)
                ? wwd_technical.images.rsd_Engine_Sunday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "rsd_Engine_Sunday_Image",
              "comments": []
            }
          }
        ]
      },

      // Filter Deck + Engine
      {
        "dropdownName": "Filter Deck + Engine",
        "rowId": (wwd_technical && wwd_technical.rowId) ? wwd_technical.rowId : '',
        "formId": (wwd_technical && wwd_technical.formId) ? wwd_technical.formId : '',
        'is_sync': (wwd_technical && wwd_technical.is_sync) ? wwd_technical.is_sync : '',
        "questions": [
          {
            "question": "Monday",
            "answer": {
              "text": (wwd_technical && wwd_technical.filterDeck_Engine_Monday) ? wwd_technical.filterDeck_Engine_Monday : '',
              "fieldName": "filterDeck_Engine_Monday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.filterDeck_Engine_Monday_Image)
                ? wwd_technical.images.filterDeck_Engine_Monday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "filterDeck_Engine_Monday_Image",
              "comments": []
            }
          },
          {
            "question": "Tuesday",
            "answer": {
              "text": (wwd_technical && wwd_technical.filterDeck_Engine_Tuesday) ? wwd_technical.filterDeck_Engine_Tuesday : '',
              "fieldName": "filterDeck_Engine_Tuesday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.filterDeck_Engine_Tuesday_Image)
                ? wwd_technical.images.filterDeck_Engine_Tuesday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "filterDeck_Engine_Tuesday_Image",
              "comments": []
            }
          },
          {
            "question": "Wednesday",
            "answer": {
              "text": (wwd_technical && wwd_technical.filterDeck_Engine_Wednesday) ? wwd_technical.filterDeck_Engine_Wednesday : '',
              "fieldName": "filterDeck_Engine_Wednesday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.filterDeck_Engine_Wednesday_Image)
                ? wwd_technical.images.filterDeck_Engine_Wednesday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "filterDeck_Engine_Wednesday_Image",
              "comments": []
            }
          },
          {
            "question": "Thursday",
            "answer": {
              "text": (wwd_technical && wwd_technical.filterDeck_Engine_Thursday) ? wwd_technical.filterDeck_Engine_Thursday : '',
              "fieldName": "filterDeck_Engine_Thursday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.filterDeck_Engine_Thursday_Image)
                ? wwd_technical.images.filterDeck_Engine_Thursday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "filterDeck_Engine_Thursday_Image",
              "comments": []
            }
          },
          {
            "question": "Friday",
            "answer": {
              "text": (wwd_technical && wwd_technical.filterDeck_Engine_Friday) ? wwd_technical.filterDeck_Engine_Friday : '',
              "fieldName": "filterDeck_Engine_Friday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.filterDeck_Engine_Friday_Image)
                ? wwd_technical.images.filterDeck_Engine_Friday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "filterDeck_Engine_Friday_Image",
              "comments": []
            }
          },
          {
            "question": "Saturday",
            "answer": {
              "text": (wwd_technical && wwd_technical.filterDeck_Engine_Saturday) ? wwd_technical.filterDeck_Engine_Saturday : '',
              "fieldName": "filterDeck_Engine_Saturday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.filterDeck_Engine_Saturday_Image)
                ? wwd_technical.images.filterDeck_Engine_Saturday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "filterDeck_Engine_Saturday_Image",
              "comments": []
            }
          },
          {
            "question": "Sunday",
            "answer": {
              "text": (wwd_technical && wwd_technical.filterDeck_Engine_Sunday) ? wwd_technical.filterDeck_Engine_Sunday : '',
              "fieldName": "filterDeck_Engine_Sunday",
              "comments": []
            },
            "images": {
              "list": (wwd_technical && wwd_technical.images && wwd_technical.images.filterDeck_Engine_Sunday_Image)
                ? wwd_technical.images.filterDeck_Engine_Sunday_Image.map(image => ({
                    src: isImageUrlTechnical ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "filterDeck_Engine_Sunday_Image",
              "comments": []
            }
          }
        ]
      },

      // MLC + Weekly Living Space Inspection
      {
        "dropdownName": "MLC + Weekly Living Space Inspection",
        "rowId": (wwd_mlc && wwd_mlc.rowId)
          ? wwd_mlc.rowId
          : '',
        "formId": (wwd_mlc && wwd_mlc.formId)
          ? wwd_mlc.formId
          : '',
        'is_sync': (wwd_mlc && wwd_mlc.is_sync)
          ? wwd_mlc.is_sync
          : '',
        "questions": [

          {
            "question": "Sanitary and Laundry Facilities",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.mlc_Sanitary_Laundry_Facilities)
                ? wwd_mlc.mlc_Sanitary_Laundry_Facilities
                : '',
              "fieldName": "mlc_Sanitary_Laundry_Facilities",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_Sanitary_Laundry_Facilities_Image)
                ? wwd_mlc.images.mlc_Sanitary_Laundry_Facilities_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "mlc_Sanitary_Laundry_Facilities_Image",
              "comments": []
            }
          },

          {
            "question": "Galley and Storage Room",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.mlc_Galley_Storage_Room)
                ? wwd_mlc.mlc_Galley_Storage_Room
                : '',
              "fieldName": "mlc_Galley_Storage_Room",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_Galley_Storage_Room_Image)
                ? wwd_mlc.images.mlc_Galley_Storage_Room_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "mlc_Galley_Storage_Room_Image",
              "comments": []
            }
          },

          {
            "question": "Mess Room",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.mlc_Mess_Room)
                ? wwd_mlc.mlc_Mess_Room
                : '',
              "fieldName": "mlc_Mess_Room",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_Mess_Room_Image)
                ? wwd_mlc.images.mlc_Mess_Room_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "mlc_Mess_Room_Image",
              "comments": []
            }
          },

          {
            "question": "Sleeping Room / Cabin",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.mlc_Sleeping_Room)
                ? wwd_mlc.mlc_Sleeping_Room
                : '',
              "fieldName": "mlc_Sleeping_Room",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_Sleeping_Room_Image)
                ? wwd_mlc.images.mlc_Sleeping_Room_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "mlc_Sleeping_Room_Image",
              "comments": []
            }
          },

          {
            "question": "Hospital Accommodation",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.mlc_Hospital_Acc)
                ? wwd_mlc.mlc_Hospital_Acc
                : '',
              "fieldName": "mlc_Hospital_Acc",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_Hospital_Acc_Image)
                ? wwd_mlc.images.mlc_Hospital_Acc_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "mlc_Hospital_Acc_Image",
              "comments": []
            }
          },

          {
            "question": "General",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.mlc_General)
                ? wwd_mlc.mlc_General
                : '',
              "fieldName": "mlc_General",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_General_Image)
                ? wwd_mlc.images.mlc_General_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "mlc_General_Image",
              "comments": []
            }
          },

          {
            "question": "Ch, cook",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.mlc_Ch_Cook)
                ? wwd_mlc.mlc_Ch_Cook
                : '',
              "fieldName": "mlc_Ch_Cook",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_Ch_Cook_Image)
                ? wwd_mlc.images.mlc_Ch_Cook_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "mlc_Ch_Cook_Image",
              "comments": []
            }
          },
        ]
      },

      // House Keeping Inspection
      {
        "dropdownName": "House Keeping Inspection",
        "rowId": (wwd_mlc && wwd_mlc.rowId)
          ? wwd_mlc.rowId
          : '',
        "formId": (wwd_mlc && wwd_mlc.formId)
          ? wwd_mlc.formId
          : '',
        'is_sync': (wwd_mlc && wwd_mlc.is_sync)
          ? wwd_mlc.is_sync
          : '',
        "questions": [

          {
            "question": "Bridge",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.hki_Bridge)
                ? wwd_mlc.hki_Bridge
                : '',
              "fieldName": "hki_Bridge",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.hki_Bridge_Image)
                ? wwd_mlc.images.hki_Bridge_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "hki_Bridge_Image",
              "comments": []
            }
          },

          {
            "question": "Accommodation Areas",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.hki_Accomodation_Area)
                ? wwd_mlc.hki_Accomodation_Area
                : '',
              "fieldName": "hki_Accomodation_Area",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.mlc_Mess_Room_Image)
                ? wwd_mlc.images.hki_Accomodation_Area_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "hki_Accomodation_Area_Image",
              "comments": []
            }
          },

          {
            "question": "On Deck - Stores",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.hki_Od_Store)
                ? wwd_mlc.hki_Od_Store
                : '',
              "fieldName": "hki_Od_Store",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.hki_Od_Store_Image)
                ? wwd_mlc.images.hki_Od_Store_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "hki_Od_Store_Image",
              "comments": []
            }
          },

          {
            "question": "Engine Room",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.hki_Engine_Room)
                ? wwd_mlc.hki_Engine_Room
                : '',
              "fieldName": "hki_Engine_Room",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.hki_Engine_Room_Image)
                ? wwd_mlc.images.hki_Engine_Room_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "hki_Engine_Room_Image",
              "comments": []
            }
          },

          {
            "question": "Steearing Room",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.hki_Steearing_Room)
                ? wwd_mlc.hki_Steearing_Room
                : '',
              "fieldName": "hki_Steearing_Room",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.hki_Steearing_Room_Image)
                ? wwd_mlc.images.hki_Steearing_Room_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "hki_Steearing_Room_Image",
              "comments": []
            }
          },

          {
            "question": "On Deck - LSA FFA Store / Fire Station / CO2 Room",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.hki_Od_Lfc)
                ? wwd_mlc.hki_Od_Lfc
                : '',
              "fieldName": "hki_Od_Lfc",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.hki_Od_Lfc_Image)
                ? wwd_mlc.images.hki_Od_Lfc_Image.map(image => ({
                    src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                    sync: image.sync || false
                  }))
                : [],
              "fieldName": "hki_Od_Lfc_Image",
              "comments": []
            }
          },

          {
            "question": "On Deck - SOPEP LCKR / Paint Store / Deck Crane Post",
            "answer": {
              "text": (wwd_mlc && wwd_mlc.hki_Od_Spd)
                ? wwd_mlc.hki_Od_Spd
                : '',
              "fieldName": "hki_Od_Spd",
              "comments": []
            },
            "images": {
              "list": (wwd_mlc && wwd_mlc.images && wwd_mlc.images.hki_Od_Spd_Image)
                ? wwd_mlc.images.hki_Od_Spd_Image.map(image => ({
                  src: isImageUrlMlc ? imgBaseUrl + image.name : image.base64,
                  sync: image.sync || false
                }))
                : [],
              "fieldName": "hki_Od_Spd_Image",
              "comments": []
            }
          },
        ]
      },

    ];

    this.manualMRAPI = [
      [
        {
          "name": "Water Test Result",
          "rowId": (wwd_technical && wwd_technical.rowId)
            ? wwd_technical.rowId
            : '',
          "formId": (wwd_technical && wwd_technical.formId)
            ? wwd_technical.formId
            : '',
          'is_sync': (wwd_technical && wwd_technical.is_sync)
            ? wwd_technical.is_sync
            : '',
          "fieldName": "mr_Water_Test_Result",
        },
        {
          "name": "Lube Oil Test Result",
          "rowId": (wwd_technical && wwd_technical.rowId)
            ? wwd_technical.rowId
            : '',
          "formId": (wwd_technical && wwd_technical.formId)
            ? wwd_technical.formId
            : '',
          "fieldName": "mr_Lube_Oil_Test_Result",
        },
        {
          "name": "Operation Summary",
          "rowId": (wwd_technical && wwd_technical.rowId)
            ? wwd_technical.rowId
            : '',
          "formId": (wwd_technical && wwd_technical.formId)
            ? wwd_technical.formId
            : '',
          "fieldName": "mr_Operation_Summary",
        },
        {
          "name": "ROB Quantity",
          "rowId": (wwd_technical && wwd_technical.rowId)
            ? wwd_technical.rowId
            : '',
          "formId": (wwd_technical && wwd_technical.formId)
            ? wwd_technical.formId
            : '',
          "fieldName": "mr_ROB_Quantity",
        },
      ]
    ]
    console.log("check-manual-api", this.manualAPI);
  }

  getCommentsForAllQuestions() {
    // console.log("Starting to fetch comments for all questions...");
    this.commentHolder = [];
    this.manualAPI.forEach(item => {
      // console.log(`Processing item with rowId: ${item.rowId}, formId: ${item.formId}`);
      item.questions.forEach(question => {
        // console.log(`Checking question: ${question.answer.fieldName}`);
        if (question.answer.text || (question.images.list && question.images.list.length > 0)) {
          // console.log("Answer or images found, proceeding to fetch comments.");
          if (item.rowId && item.formId) {
            // console.log(`Fetching comments for answer field: ${question.answer.fieldName}`);
            // Fetch comments for answer field
            this.getComments(item.rowId, item.formId, question.answer.fieldName)
              .then(comments => {
                // console.log(`Fetched comments for answer field: ${question.answer.fieldName}`, comments);
                this.commentHolder = [...this.commentHolder, ...comments]; // Append comments
              })
              .catch(error => {
                // console.error(`Error fetching comments for answer field: ${question.answer.fieldName}`, error);
              });
            // console.log(`Fetching comments for image field: ${question.images.fieldName}`);
            this.getComments(item.rowId, item.formId, question.images.fieldName)
              .then(comments => {
                // console.log(`Fetched comments for image field: ${question.images.fieldName}`, comments);
                this.commentHolder = [...this.commentHolder, ...comments]; // Append comments
              })
              .catch(error => {
                // console.error(`Error fetching comments for image field: ${question.images.fieldName}`, error);
              });
          }
        } else {
          // console.log("No answer or images found for this question.");
        }
      });
    });

    this.manualMRAPI.forEach(section => {
      // console.log(`Processing section:`, section);
      section.forEach(item => {
        // console.log(`Processing item with rowId: ${item.rowId}, formId: ${item.formId}`);
        if (item.rowId && item.formId) {
          // console.log(`Fetching comments for field: ${item.fieldName}`);
          this.getComments(item.rowId, item.formId, item.fieldName)
            .then(comments => {
              // console.log(`Fetched comments for field: ${item.fieldName}`, comments);
              this.commentHolder = [...this.commentHolder, ...comments];
            })
            .catch(error => {
              // console.error(`Error fetching comments for field: ${item.fieldName}`, error);
            });
        }
      });
    });
    // console.log("Finished fetching comments for all questions.");
  }

  getComments(rowId: string, formId: number, fieldName: string): Promise<any[]> {
    // console.log(`Fetching comments for rowId: ${rowId}, formId: ${formId}, fieldName: ${fieldName}`);
    return this.fetchComments(rowId, formId, fieldName, false);
    // console.log(`Comments for fieldName: ${fieldName} fetched successfully.`);
  }

  addNewComment(rowId: string, formId: number, fieldName: string): Promise<any[]> {
    // console.log(`Adding new comment for rowId: ${rowId}, formId: ${formId}, fieldName: ${fieldName}`);
    return this.fetchComments(rowId, formId, fieldName, true);
    // console.log(`New comment added for fieldName: ${fieldName}`);
  }

  private fetchComments(rowId: string, formId: number, fieldName: string, shouldAdd: boolean): Promise<any[]> {
    return new Promise((resolve, reject) => {
      // console.log(`Fetching comments for rowId: ${rowId}, formId: ${formId}, fieldName: ${fieldName}, shouldAdd: ${shouldAdd}`);
      this.rs.getCommentsDetails(rowId, formId, fieldName, (response) => {
        // console.log(`Received response: ${JSON.stringify(response)}`);
        if (Number(response.responsecode) == 200) {
          // console.log('Response code 200, processing comments.');
          if (shouldAdd) {
            const uniqueComments = response.data.filter(newComment =>
              !this.commentHolder.some(existingComment => existingComment.id === newComment.id)
            );
            // console.log(`Found unique comments to add: ${JSON.stringify(uniqueComments)}`);
            this.commentHolder = [...this.commentHolder, ...uniqueComments];
          }
          this.cdr.markForCheck();
          resolve(response.data);
        } else {
          // console.log('Response code not 200, resolving with empty array.');
          resolve([]);
        }
      });
    });
  }

  getPostedTime(actionDateTime: number): string {
    // console.log(`Calculating posted time for actionDateTime: ${actionDateTime}`);
    const now = new Date();
    const commentDate = new Date(actionDateTime);
    const diffInMs = now.getTime() - commentDate.getTime();
    // console.log(`Time difference in milliseconds: ${diffInMs}`);
    const diffInHours = diffInMs / (1000 * 60 * 60);
    if (diffInHours < 24) {
      if (diffInHours < 1) {
        const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
        // console.log(`Less than an hour ago, minutes difference: ${diffInMinutes}`);
        return diffInMinutes === 1 ? `Posted 1 minute ago` : `Posted ${diffInMinutes} minutes ago`;
      }
      // console.log(`Posted within 24 hours, hours difference: ${Math.floor(diffInHours)}`);
      return `Posted ${Math.floor(diffInHours)} hour${Math.floor(diffInHours) > 1 ? 's' : ''} ago`;
    } else if (diffInHours < 48) {
      // console.log('Posted within 48 hours, returning "Yesterday"');
      return 'Posted Yesterday';
    } else {
      // console.log('Posted more than 48 hours ago, returning exact date');
      return commentDate.toLocaleDateString(); // Display exact date if older
    }
  }

  formatDate(dateString: string): string {
    // console.log(`Formatting date for string: ${dateString}`);
    const dateObj = new Date(dateString);
    // console.log(`Parsed Date object: ${dateObj}`);
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    };
    const formattedDate = dateObj.toLocaleDateString('en-GB', options);
    // console.log(`Formatted date before replacing spaces: ${formattedDate}`);
    return formattedDate.replace(/ /g, '-');
  }

  checkQuestionsHaveContent(questions: any[]): boolean {
    return questions.some(question => {
      // console.log('Checking question content:', question);
      // console.log('Answer text:', question.answer.text.trim());
      // console.log('Images list length:', question.images.list ? question.images.list.length : 0);
      return question.answer.text.trim() || (question.images.list && question.images.list.length > 0);
    });
  }

  updateToShore() {
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    this.setLoadingState(true);
    // console.log("Starting the syncShipToShore process...");
    this.rs.syncShipToShore(this.gdReportData.id, (res) => {
      // console.log("Response received from syncShipToShore:", res);
      // this.getWeeklyWorkDoneReortByRecordId();
      // console.log("Successfully fetched the weekly work done report.");
      this.setLoadingState(false);
      // console.log("Loading state set to false.");
      this.showSuccess("Success!", "Your data has been successfully sent to the shore.")
      // console.log("Success message displayed.");
      this.cdr.markForCheck();
      // console.log("Change detection triggered.");

      this.getWeeklyWorkDoneReortByRecordId();
    }, (error) => {
      // console.log("Error From Callback");
      this.setLoadingState(false);
      this.showError("Connection Issue", this.serverErrMsg)
      this.cdr.markForCheck();
    });
  }

  sendToVessel() {
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    this.setLoadingState(true);
    // console.log("Starting the sendToVessel process...");
    this.rs.sendToVessel(this.gdReportData.id, (response) => {
      // console.log("Response received from sendToVessel:", response);
      if (Number(response.responsecode) == 200) {
        // this.getWeeklyWorkDoneReortByRecordId();
        // console.log("Successfully fetched the weekly work done report.");
        this.setLoadingState(false);
        // console.log("Loading state set to false.");
        this.showSuccess("Success!", "Your data has been successfully sent to the vessel, it may take few minutes to update on the vessel")
        // console.log("Success message displayed.");
        this.cdr.markForCheck();
        // console.log("Change detection triggered.");
        this.getWeeklyWorkDoneReortByRecordId();
      } else {
        this.setLoadingState(false);
        // console.log("Error occurred during sendToVessel.");
        this.showError('Error', response.message);
        // console.log("Error message displayed:", response.message);
      }
    }, (error) => {
      // console.log("Error Callback")
      this.setLoadingState(false)
      this.showError("Connection Issue", this.serverErrMsg)
      this.cdr.markForCheck();
    });
  }

  closeWWDReport() {
    if (!navigator.onLine) {
      // console.log("No internet connection. Please check your network.");
      this.setLoadingState(false);
      this.showError("Network Error", this.deviceErrMsg)
      return;
    }

    // console.log("Opening the closebox...");
    this.closebox.show();
    // console.log("closebox shown.");
  }

  closeReport() {

    // console.log("Starting to close the report...");
    this.setLoadingState(true);
    this.rs.closeReport(this.gdReportData.id, (response) => {
      // console.log("Response received:", response);
      this.setLoadingState(false);
      if (Number(response.responsecode) == 200) {
        // console.log("Report closed successfully.");
        this.showSuccess('Success!', 'Your report has been closed successfully, it may take a few minutes to update on the vessel')
        // console.log("Getting weekly work done report...");
        // this.getWeeklyWorkDoneReortByRecordId();
        this.cdr.markForCheck();
      } else {
        // console.log("Error occurred while closing the report:", response.message);
        this.setLoadingState(false);
        this.showError('Error', response.message);
      }
    }, (error) => {
      // console.log("Error Appeared");
      this.setLoadingState(false);
      this.showError("Connection Issue", this.serverErrMsg)
      this.cdr.markForCheck();
    })
  }

  getWeeklyWorkDoneReortByRecordId() {
    // console.log("Fetching weekly work done report with record ID:", this.gdReportData.id);
    this.rs.getWeeklyWorkDoneReortByRecordId(this.gdReportData.id, (response) => {
      // console.log("Response received for weekly work done report:", response);

      if (response.responsecode === 200 || response.responsecode === '200') {
        // console.log("Report fetched successfully. Updating status...");
        this.gdReportData.status = response.data.status;
        this.gdReportData = response.data;
      } else {
        // console.log("Error fetching report:", response.message);
      }
    })
  }

  getShortName(fullName: string) {
    // console.log("Input fullName:", fullName);
    if (fullName != null) {
      var fn = fullName.split(' ');
      // console.log("Splitted full name:", fn);
      var charAt1 = '';
      var charAt2 = '';
      var charAt3 = '';
      if (fn[0] != undefined) {
        charAt1 = fn[0].charAt(0);
        charAt1 = charAt1.toUpperCase();
        // console.log("First character of first name:", charAt1);
      }
      if (fn[1] != undefined) {
        charAt2 = fn[1].charAt(0);
        charAt2 = charAt2.toUpperCase();
        // console.log("First character of second name:", charAt2);
      }
      if (fn[2] != undefined) {
        charAt3 = fn[2].charAt(0);
        charAt3 = charAt3.toUpperCase();
        // console.log("First character of third name:", charAt3);
      }
      // console.log("Generated short name:", charAt1 + charAt2 + charAt3);
      return charAt1 + charAt2 + charAt3;
    }
  }

  generateUniqueId(name: string): string {
    if (name) {
      // console.log("Input name:", name);
      const timestamp = Date.now();
      // console.log("Timestamp:", timestamp);
      const nameHash = this.getNameHash(name);
      // console.log("Name Hash:", nameHash);
      let unique = timestamp + nameHash;
      // console.log("Combined unique value:", unique);
      return unique.toString().slice(0, 10);
      // console.log("Final unique ID:", unique.toString().slice(0, 10));
    } else {
      return '';
    }
  }

  getNameHash(name: string): number {
    let hash = 0;
    // console.log("Input name:", name);
    for (let i = 0; i < name.length; i++) {
      const charCode = name.charCodeAt(i);
      // console.log(`Character at position ${i}:`, name[i], "Character code:", charCode);
      hash += charCode;
    }
    // console.log("Final hash:", hash);
    return hash;
  }

  onImageClick(image: string): void {
    // console.log("Image clicked:", image);
    this.selectedImage = image;
    // console.log("Selected image updated:", this.selectedImage);
  }

  closePopup(): void {
    // console.log("Closing popup. Clearing selected image.");
    this.selectedImage = null;
    // console.log("Selected image after clearing:", this.selectedImage);
  }


  filterListByDateRange() {
    // Apply date range filter if both dates are set
    if (this.fromDate && this.toDate) {
      const from = new Date(this.fromDate);
      const to = new Date(this.toDate);
      console.log('==from==', from);
      console.log('==to==', to);

      this.filteredFormRecordsList = this.filteredFormRecordsList.filter((item) => {
        const itemDate = this.parseCustomDate(item.formDate);  // use parseCustomDate if needed
        console.log('==itemDate==', itemDate);

        return itemDate >= from && itemDate <= to;
      });

      console.log('after-date-format', this.filteredFormRecordsList);
    }

    else if (this.fromDate) {
      // Filter by "from" date
      const from = new Date(this.fromDate);
      this.filteredFormRecordsList = this.filteredFormRecordsList.filter(item => {
        const itemDate = this.parseCustomDate(item.formDate);
        return itemDate >= from;
      });
    } else if (this.toDate) {
      // Filter by "to" date
      const to = new Date(this.toDate);
      this.filteredFormRecordsList = this.filteredFormRecordsList.filter(item => {
        const itemDate = this.parseCustomDate(item.toDate);
        return itemDate <= to;
      });
    } else {
      // If no date range is set, show full list
      this.filteredFormRecordsList = this.reportList;;
    }
  }


  filterListByStatus() {
    var filtered = this.reportList;
    console.log('==filtered==', filtered);
    console.log('vijya', this.selectedStatus)
    console.log('vijyatype', typeof (this.selectedStatus))

    if (Number(this.selectedStatus) === 5) {
      console.log('==reportList==', this.reportList);
      this.filteredFormRecordsList = this.reportList;
      console.log('==final=filteredFormRecordsList==', this.filteredFormRecordsList);
    }

    // Apply status filter if any
    if (Number(this.selectedStatus) !== null && Number(this.selectedStatus) !== 5) {
      console.log('==selectedSatatus==', this.selectedStatus)
      // filtered = filtered.filter(item => Number(item.status) === this.selectedStatus);
      filtered = filtered.filter((item) => {
        console.log("==item-status==", item.status);
        console.log('==selectedSatatus==', this.selectedStatus);
        return item.status === this.selectedStatus
      })
    }

    console.log('==afyer-filtered==', filtered);

    // Apply date range filter on top
    if (this.fromDate || this.toDate) {
      filtered = filtered.filter(item => {
        const from = this.fromDate ? new Date(this.fromDate) : null;
        const to = this.toDate ? new Date(this.toDate) : null;
        const itemDate = this.parseCustomDate(item.formDate);

        if (from && to) {
          return itemDate >= from && itemDate <= to;
        } else if (from) {
          return itemDate >= from;
        } else if (to) {
          return itemDate <= to;
        }
        return true;
      });
    }

    // Finally assign the result
    this.filteredFormRecordsList = filtered;
    console.log('==final=filteredFormRecordsList==', this.filteredFormRecordsList);
  }

  clearDateFilter() {
    this.fromDate = '';
    this.toDate = '';
    this.selectedStatus = 5;
    console.log('==selectedStatus==', this.selectedStatus)
    this.filterListByStatus()
  }

  parseCustomDate(dateStr: string): Date {
    const [year, day, month] = dateStr.split('-');
    return new Date(`${year}-${month}-${day}`);  // returns valid Date object
  }

}
